import React, { useEffect, useState } from "react";
import { ConvertedBooking, getBookingsList, WINTER_CLOSURE } from "./utils";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import classes from "./Contact.module.css";

const localizer = momentLocalizer(moment);

export const WEDDING_CALENDAR_ID =
  "c_bd6b5facc9d857de8dc96439211909cde1502e667b66752092046ea82dc8f2f7@group.calendar.google.com";

// Every event on this calendar means the house is booked, so all of them are
// rendered the same way regardless of free/busy status.
export const ROBINS_ROOST_CALENDAR_ID =
  "c_e192a98f98a97ab69b4586042acacdd261ea91fbfea34f97d0b077407c7ce288@group.calendar.google.com";

const PublicCalendar = ({
  calendarId = WEDDING_CALENDAR_ID,
  showWinterClosure = true,
}: {
  calendarId?: string;
  showWinterClosure?: boolean;
}) => {
  const [bookings, setBookings] = useState<ConvertedBooking[]>([]);
  useEffect(() => {
    const loadCalendar = () => {
      var apiKey = process.env.REACT_APP_GOOGLE_API_KEY;
      var userTimeZone = "America/Los_Angeles";
      //@ts-ignore
      gapi.client
        .init({
          apiKey: apiKey,
          discoveryDocs: [
            "https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest",
          ],
        })
        .then(() => {
          //@ts-ignore
          return gapi.client.calendar.events.list({
            calendarId,
            timeZone: userTimeZone,
            singleEvents: true,
            timeMin: new Date().toISOString(),
            orderBy: "startTime",
          });
        })
        .then(
          //@ts-ignore
          (response) => {
            if (response.result.items) {
              setBookings(
                getBookingsList(
                  response.result.items,
                  showWinterClosure ? [WINTER_CLOSURE] : [],
                ),
              );
            }
          },
        );
    };

    //@ts-ignore
    gapi.load("client", loadCalendar);
  }, [calendarId, showWinterClosure]);
  return (
    <div className={classes.calendarWrapper}>
      <div className={classes.calendar}>
        <Calendar
          localizer={localizer}
          events={bookings}
          startAccessor="start"
          endAccessor="end"
          style={{ height: 500 }}
          views={["month"]}
          eventPropGetter={() => {
            return { style: { backgroundColor: "#d1e6d4", color: "black" } };
          }}
        />
      </div>
    </div>
  );
};

export default PublicCalendar;
